"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-3d-printing";

const IMAGE_BASE = "/image/new-version/more/3D-Printing/Solutions";

const CARDS = [
	{ keyPrefix: "manufacturingSolutionsCard1", image: `${IMAGE_BASE}/3d-printing.webp` },
	{ keyPrefix: "manufacturingSolutionsCard2", image: `${IMAGE_BASE}/vacuum-casting.webp` },
	{ keyPrefix: "manufacturingSolutionsCard3", image: `${IMAGE_BASE}/injection-molding.webp` },
] as const;

function CheckIcon() {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="mt-0.5 shrink-0"
			aria-hidden="true"
		>
			<circle cx="10" cy="10" r="10" fill="#83b751" />
			<path
				d="M5.5 10.2 8.5 13l6-6"
				stroke="#ffffff"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</svg>
	);
}

export default function ManufacturingSolutions() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<div className="mb-3 flex items-center justify-center gap-3 sm:mb-4">
						<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
							{t("manufacturingSolutionsBrand")}
						</h2>
						<span className="inline-block h-[4px] w-20 self-end bg-[#64a525]" />
					</div>
					<h2 className="mb-3 text-xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("manufacturingSolutionsSubtitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("manufacturingSolutionsDesc")}</p>
				</header>

				<div className="grid gap-5 sm:gap-6 md:grid-cols-2 lg:grid-cols-3">
					{CARDS.map((card) => (
						<article
							key={card.keyPrefix}
							className="flex flex-col overflow-hidden bg-[#eeeeee] shadow-sm transition-shadow duration-300 hover:shadow-md"
						>
							<div className="flex flex-1 flex-col p-5 sm:p-6">
								<span className="mb-4 text-xs text-gray-500 sm:text-sm">{t(`${card.keyPrefix}Label`)}</span>
								<h3 className="mb-3 text-lg font-bold leading-snug text-black sm:text-xl md:text-2xl">
									{t(`${card.keyPrefix}Title`)}
								</h3>
								<p className="mb-4 flex-1 text-sm leading-relaxed text-black md:text-base">
									{t(`${card.keyPrefix}Desc`)}
								</p>
								<div className="flex items-start gap-2 text-sm leading-relaxed text-black md:text-base">
									<CheckIcon />
									<span>{t(`${card.keyPrefix}Highlight`)}</span>
								</div>
							</div>
							<div className="relative aspect-[16/10] w-full bg-[#eeeeee]">
								<Image
									src={card.image}
									alt={t(`${card.keyPrefix}Alt`)}
									fill
									className="object-contain px-4"
									sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
								/>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
